module.exports = __webpack_public_path__ + "img/junior-novice.af9175e1.jpg";